import React from 'react'
import {Link} from 'react-router-dom'

import withSlider from '../hoc/with-slider'

const ProductCardSlider = ({id, index, images, isViewedArrow, handleArrowClick, updateSliderBackgrounds}) => {
  const imagesList = images.map((image, i) => {
    if (i > 2) {
      return null
    }
    return (
      <div className={`favourite-product-slider__item favourite-product-slider__item-${i + 1}`}
           style={updateSliderBackgrounds(index + i)}
           key={i}>
        <Link data-id={index + i} to={`/product-card-desktop/${id}`}/>
      </div>
    )
  });

  return (
    <div className="favourite-product-slider">
      {isViewedArrow && <div className="favourite-product-slider__arrow favourite-product-slider__arrow_up arrow-up"
           onClick={handleArrowClick}/>}
      {imagesList}
      {isViewedArrow && <div className="favourite-product-slider__arrow favourite-product-slider__arrow_down arrow-down"
           onClick={handleArrowClick}/>}
    </div>
  )
};

export default withSlider(ProductCardSlider)